import { queryOptions } from '@tanstack/vue-query';
import { PriorityQueryKey } from '@/modules/common/enums/query-key.enum.ts';
import { SegmentApi } from '@/modules/counterparty/api/segment.api.ts';

export class SegmentQueryOptions {
  static BASE_KEY = 'segment';

  static getList(signal?: AbortSignal) {
    return queryOptions({
      queryKey: [PriorityQueryKey.Secondary, SegmentQueryOptions.BASE_KEY],
      queryFn: (meta) => SegmentApi.getList(signal ?? meta.signal),
    });
  }
}
